import React from 'react'
import { useTranslation } from 'react-i18next';
import TimerComponent2 from '../../timer/TimerComponent2';
import FullScreenDropdown from '../../../../Components/Common/FullScreenDropdown';

const Template2Header = (props) => {
  const { handelExit, direction, stdName, trafficId, examType, examDuration, handleTimeUp, isReviewMode, index, totalQuestion, courseName, courseShortName, reviewAfterMarkedStack, handleReviewAfter, isShowRevSection } = props;
  const { t } = useTranslation();

  return (
    <>
      <header id="page-topbar" className="exam-header template2-exam-header" style={{ position: "unset" }}>
        <div className="bg-primary layout-fluid">
          <div className="navbar-header px-3 py-2 template2-header-bar">
            <div className="row w-100 align-items-center g-2 g-lg-3">
              <div className="col-12 col-lg-6 practice-heading">
                <h4 className="text-light fw-bold mb-1 template2-student-line">{stdName} | {trafficId}</h4>
                <div className="d-flex gap-2 text-light flex-wrap align-items-center template2-course-line">
                  <div className="template2-course-title">
                    <i className="ri-book-line align-bottom me-1"></i>
                    {courseName} {examType == 1 && courseShortName == "MCD" ? "Theory Test" : ""}
                  </div>
                  <div className="vr d-none d-sm-block"></div>
                  <div className="badge rounded-pill bg-warning fs-12">{examType == 1 ? 'Exam' : 'Practice'}</div>
                </div>
              </div>

              <div className="col-12 col-lg-4">
                <div className="vstack gap-1 template2-timer-block">
                  <div className={`${direction === 'ltr' ? 'me-lg-2' : 'ms-lg-2'} template2-timer-wrap`}>
                    <TimerComponent2
                      duration={examDuration}
                      handleTimeUp={handleTimeUp}
                      examType={examType}
                    />
                  </div>
                  <h6 className={`mb-0 text-white template2-index-line ${direction === 'ltr' ? 'text-lg-end text-start' : 'text-lg-start text-start'}`} style={{ direction: "ltr" }}>
                    <span className={`mb-0 text-white fw-bold ${direction === 'ltr' ? 'me-1' : 'ms-1'}`}>#</span>
                    <span className="index-val">{index + 1}</span>/<span className="total-question">{totalQuestion}</span>
                  </h6>
                </div>
              </div>

              <div className="col-12 col-lg-2 d-flex align-items-center justify-content-lg-end gap-2 flex-wrap template2-header-tools">
                {examType == 2 ?
                  <div className="header-item d-sm-flex">
                    <button className="btn btn-icon btn-top-bar btn-ghost-secondary rounded-circle" title='Exit' onClick={() => { handelExit() }}>
                      <i className="bx bx-exit fs-22 text-light"></i>
                    </button>
                  </div>
                  : ''}
                <FullScreenDropdown />
                {isReviewMode ?
                  <i className='ri-close-line fs-36 text-light cursor-pointer' onClick={() => { handelExit() }} title={t('Exit Review')}></i>
                  : ''}

                {examType == 1 && !isShowRevSection ?
                  <div className="form-check mb-0 review-later-wrap">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="formCheck6"
                      onChange={(e) => handleReviewAfter(e, index)}
                      checked={reviewAfterMarkedStack.includes(index)}
                      style={{ backgroundColor: "#ffffff", borderColor: "#ffffff" }}
                    />
                    <label className="form-check-label text-white review-later-text" htmlFor="formCheck6">{t('Review Later')}</label>
                  </div>
                  : ''}
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

export default Template2Header
